import { render, staticRenderFns } from "./CaratSelectionList.vue?vue&type=template&id=521521f2&"
import script from "./CaratSelectionList.vue?vue&type=script&lang=js&"
export * from "./CaratSelectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports